import { date } from 'quasar'
import i18n from 'src/i18n/i18n'
import parseDate from 'date-fns/parse'
import { trim } from 'lodash'

const mapSearchResult = model => {
  switch (model.search_type) {
  case 'customer':
    return mapCustomer(model)
  case 'invoice':
    return mapInvoice(model)
  case 'quote':
    return mapQuote(model)
  case 'item':
    return mapItem(model)
  case 'recurring_invoice':
    return mapRecurringInvoice(model)
  case 'project':
    return mapProject(model)
  }
}

const mapCustomer = customer => {
  const company = customer.company ? customer.company.data : null

  return {
    value: customer,
    icon: customer.type === 'company' ? 'business' : 'person',
    label: getCustomerName(customer),
    sublabel: customer.type === `contact_person` ? company.name : customer.customer_number
  }
}

const mapInvoice = invoice => {
  const customer = invoice.customer.data
  const invoiceNumber = invoice.invoice_number || i18n.t('draft')

  return {
    value: invoice,
    icon: 'receipt',
    label: invoice.invoice_title,
    sublabel: `${invoiceNumber} - ${getCustomerName(customer)}`,
    stamp: date.formatDate(parseDate(invoice.invoice_date.date), i18n.t('date_format'))
  }
}

const mapQuote = quote => {
  const customer = quote.customer.data
  const quoteNumber = quote.quote_number || i18n.t('draft')

  return {
    value: quote,
    icon: 'local_offer',
    label: quote.quote_title,
    sublabel: `${quoteNumber} - ${getCustomerName(customer)}`,
    stamp: quote.valid_until ? date.formatDate(parseDate(quote.valid_until.date), i18n.t('date_format')) : null
  }
}

const mapItem = item => {
  return {
    value: item,
    icon: 'local_mall',
    label: item.item_name,
    sublabel: item.item_number
  }
}

const mapRecurringInvoice = invoice => {
  const customer = invoice.customer.data

  return {
    value: invoice,
    icon: 'receipt',
    label: invoice.invoice_title,
    sublabel: getCustomerName(customer),
    stamp: i18n.t('recurring')
  }
}

const mapProject = project => {
  const customer = project.customer ? project.customer.data : null

  return {
    value: project,
    icon: 'folder',
    label: project.name,
    sublabel: customer ? getCustomerName(customer) : null,
    stamp: !project.active ? i18n.t('archived') : null
  }
}

const getCustomerName = customer => {
  return customer.type === 'company' ? customer.name : trim([trim([customer.last_name, customer.first_name].join(', '), ', '), customer.title].join(', '), ', ')
}

export { mapSearchResult, mapCustomer, getCustomerName }
